export function toISODate(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function initialsFromName(name) {
  const trimmed = (name || '').trim();
  return trimmed ? trimmed.charAt(0).toUpperCase() : 'U';
}

export function countFilledFields(formData, fieldNames) {
  const filled = fieldNames.filter((name) => String(formData[name] ?? '').trim()).length;
  return { filled, total: fieldNames.length };
}

export function progressFillClass(percent) {
  if (percent < 50) return 'is-low';
  if (percent < 100) return 'is-mid';
  return 'is-complete';
}

export function formatDisplayDate(value) {
  if (value == null || value === '') return '';

  const raw = String(value);
  const isoDate = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDate) {
    return `${Number(isoDate[2])}/${Number(isoDate[3])}/${isoDate[1]}`;
  }

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return raw;
  return `${parsed.getMonth() + 1}/${parsed.getDate()}/${parsed.getFullYear()}`;
}

export function choiceClassName(value) {
  return String(value || 'unknown')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-');
}

export function toCsvValue(value) {
  const text = String(value ?? '');
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function buildRegisterCsv(items, columns) {
  const header = columns.map((column) => toCsvValue(column.label)).join(',');
  const rows = items.map((item) =>
    columns
      .map((column) => {
        const value = column.kind === 'date'
          ? formatDisplayDate(item[column.key])
          : item[column.key];
        return toCsvValue(value);
      })
      .join(',')
  );
  return `\uFEFF${[header, ...rows].join('\r\n')}`;
}

export function downloadTextFile(filename, text, mimeType = 'text/csv;charset=utf-8') {
  const blob = new Blob([text], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
